export default __webpack_public_path__ + "static/media/1827.1634dd1f.png";